// extracted by mini-css-extract-plugin
export var flag = "ProductFlags-module--flag--9f5d9";
export var flagContainer = "ProductFlags-module--flagContainer--37ed8";
export var maroon = "ProductFlags-module--maroon--de10c";
export var orange = "ProductFlags-module--orange--5a349";
export var sale = "ProductFlags-module--sale--125a1";
export var yellow = "ProductFlags-module--yellow--a77ae";